module.exports = ".edit-csv-upload .edit-flush-btn {\n  margin: 25px 2px 2px;\n}\n.edit-csv-upload .edit-upload-error {\n  color: #cd202c;\n}\n.edit-csv-upload .edit-driver-type-select /deep/ .dropdown {\n  display: block;\n  margin-top: 10px;\n}\n.edit-csv-upload .edit-clickable {\n  cursor: pointer;\n}\n.edit-csv-upload .edit-module-template {\n  margin-bottom: 5px;\n}\n.edit-csv-upload .edit-driver-template {\n  margin-bottom: 5px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/management/components/csvupload/upload.less
// module id = ./src/app/management/components/csvupload/upload.less
// module chunks = main